//https://stackoverflow.com/questions/34164413/how-to-apply-filters-to-ngfor
import { PipeTransform, Pipe } from '@angular/core';
import { Observable } from 'rxjs';

@Pipe({
    name: 'callback',
    pure: false
})
export class CallbackPipe implements PipeTransform {
    transform(items: any, callback: (item: any, search: string) => boolean, searchStr: string): any {
        if (!items || !callback) {
            return items;
        }
        var result: any[];
        if (Array.isArray(items)) {
            result = items.filter(item => callback(item, searchStr));
        } else {
            result = items.array();
        }
        return result;
    }
}
